module.exports = __webpack_public_path__ + "img/14.bcf609bb.jpg";